import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer id="footer">
      <span>Pedro Henrique Santana de Menezes @2023</span>
      {/* <span>Desenvolvedor fullstack</span> */}
    </footer>
  )
}

export default Footer;